import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PrivateRoute from './config/private-route';
import LessonPage from '.';
import { fetchToken, setUserEmail } from '../../redux/personaliseLessons/authenticationSlice';
import { useDispatch, useSelector } from 'react-redux';
import { fetchCourseList, updateCourseName } from '../../redux/personaliseLessons/courseListSlice';
import { toast } from 'react-toastify';
import { Mixpanel } from '../../config/Mixpanel';
import Loader from './components/Loader';
import { fetchCourseModule } from '../../redux/personaliseLessons/courseModuleSlice';

const Authenticate = () => {

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const emailID = useSelector((store) => store?.profileDetails?.email);
    const target = params.get('target');
    const {course_slug, module_slug, lesson_slug} = useParams();
    const [welcomePageLoading, setWelcomePageLoading] = useState(true);


    

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const quizRef = useRef(null);


    useEffect(() => {
        if (emailID){
            const fetchData = async () => {
                dispatch(setUserEmail(emailID))
                try {
                    const response = await dispatch(fetchToken({ email_id: emailID })).unwrap()
                    if (!response?.Error){
                        Mixpanel.identify(emailID);
                        const courseResponse = await dispatch(fetchCourseList({ uid: response?.uid })).unwrap()
                        const firstSubject = courseResponse?.subject_names?.[0]
                        if (!firstSubject) {
                            toast.error("No courses found! Please try again later.")
                            navigate('/login', { replace: true })
                            return
                        }
                        let index = courseResponse?.subject_names?.length - 1
                        dispatch(updateCourseName(course_slug))
                        dispatch(fetchCourseModule({ uid: response?.uid, subject_name: course_slug }))
                        // if (skillName){
                        //     let courseIndex = courseResponse?.subject_names?.findIndex((item) => item.toLowerCase() ===  skillName.toLowerCase())
                        //     if (courseIndex !== -1){
                        //         index = courseIndex
                        //     }
                        // }
                        // await helperFunction(emailID, courseResponse?.subject_names?.[index])
                    }
                }catch (err) {
                    console.log(err.message);
                }finally{
                    setWelcomePageLoading(false)
                }
            }
            fetchData()
        }
    }, [dispatch, emailID, navigate])


    useEffect(() => {
        setTimeout(() => {
            if(target === "goal" && quizRef.current){
                quizRef.current.scrollIntoView({ behavior: 'smooth' })
            }
        }, 4000)
    }, [target, quizRef])



if(welcomePageLoading && emailID){
    return <Loader/>
}
  return (
    <PrivateRoute>
        <LessonPage quizRef={quizRef}/>
    </PrivateRoute>
  )
}

export default Authenticate